import Templates from '../../../base/pages/templates';

const templates: Templates = {
  selectTemplate: 'Schablone auswählen',
  update: 'Aktualisieren'
};

export default templates;
